import { render, staticRenderFns } from "./FacilitiesChinaPage.vue?vue&type=template&id=4364f06a&scoped=true&"
import script from "./FacilitiesChinaPage.vue?vue&type=script&lang=js&"
export * from "./FacilitiesChinaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4364f06a",
  null
  
)

export default component.exports